import { useAppSelector } from '@online-webinar/store';
import { DateTime } from 'luxon';
import { getI18n } from 'react-i18next';

export const BroadcastDate = () => {
    const startOn = useAppSelector((state) => state.liveWebinar.startOn);
    if (!startOn) {
        return null;
    }
    return (
        <div className="font-accent lg:text-lg leading-tight lg:leading-tight">
            {DateTime.fromISO(startOn).toLocal().setLocale(getI18n().language).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)}
        </div>
    );
};
